import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-floating-loader',
    templateUrl: './floating-loader.component.html',
    styleUrl: './floating-loader.component.scss'
})
export class FloatingLoaderComponent {
    @Input() isLoading: boolean = false;
    @Input() message: string = 'Loading...';
    @Input() size: 'small' | 'medium' | 'large' = 'medium';

    get loaderSize() {
        switch (this.size) {
            case 'small': return 'w-6 h-6';
            case 'large': return 'w-12 h-12';
            default: return 'w-8 h-8';
        }
    }

    get messageSize() {
        switch (this.size) {
            case 'small': return 'text-xs';
            case 'large': return 'text-base';
            default: return 'text-sm';
        }
    }
}
